import React, { useState } from "react";
import { useSaveRequestMutation } from "../api/starterKitApi";
import { useCourse } from "../../configuration/course/hooks/useCourse";
import CommonSelect from "../../../core/common/commonSelect";
import { showToast } from "../../../core/utils/alert";
import { getApiErrorMessage } from "../../../core/utils/errorHandler";

const CreateRequestModal = () => {
  const [courseId, setCourseId] = useState<number | null>(null);
  const [quantity, setQuantity] = useState<number | "">("");

  const { getCourseState } = useCourse();
  const { courses } = getCourseState();

  const [saveRequest, { isLoading }] = useSaveRequestMutation();

  const courseOptions = courses.map((c: any) => ({
    value: c.id.toString(),
    label: c.name,
  }));

  const resetForm = () => {
    setCourseId(null);
    setQuantity("");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!courseId) {
      showToast({ title: "Error", text: "Please select a course", icon: "error" });
      return;
    }
    if (!quantity || quantity <= 0) {
      showToast({ title: "Error", text: "Please enter a valid quantity", icon: "error" });
      return;
    }

    try {
      const response = await saveRequest({
        course_id: courseId,
        quantity: Number(quantity),
      }).unwrap();

      if (response.success) {
        showToast({ title: "Success", text: response.message, icon: "success" });
        document.getElementById("close_create_request")?.click();
        resetForm();
      } else {
        showToast({ title: "Error", text: response.message || "Failed to create request", icon: "error" });
      }
    } catch (error: any) {
      showToast({ title: "Error", text: getApiErrorMessage(error) || "Something went wrong", icon: "error" });
    }
  };

  const handleClose = () => {
    resetForm();
  };

  return (
    <div className="modal fade" id="create_request_modal" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Request Starter Kits</h5>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="close_create_request"
              onClick={handleClose}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Course <span className="text-danger">*</span></label>
                <CommonSelect
                  className="select"
                  options={courseOptions}
                  value={courseOptions.find((c) => c.value === courseId?.toString())}
                  onValueChange={(val) => setCourseId(val ? Number(val) : null)}
                  placeholder="Select Course"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Quantity <span className="text-danger">*</span></label>
                <input
                  type="number"
                  className="form-control"
                  value={quantity}
                  onChange={(e) => setQuantity(Number(e.target.value))}
                  min="1"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={isLoading}>
                {isLoading ? "Submitting..." : "Submit Request"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateRequestModal;
